import { useTranslation } from "react-i18next";

const normalizeLanguageCode = (languageCode = "") => {
  const shortCode = String(languageCode).toLowerCase().split("-")[0];
  return shortCode === "jp" ? "ja" : shortCode;
};

/**
 * Custom hook for i18next translations
 *
 * Usage example:
 * const { t, i18n } = useI18n();
 *
 * // In JSX:
 * <button>{t('save')}</button>
 *
 * // Change language:
 * i18n.changeLanguage('en');
 */
export const useI18n = () => {
  const { t, i18n } = useTranslation();

  const changeLanguage = (lang) => {
    i18n.changeLanguage(normalizeLanguageCode(lang));
  };

  return {
    t,
    i18n,
    changeLanguage,
    currentLanguage: normalizeLanguageCode(i18n.language),
  };
};
